import { createRoute } from '@tanstack/react-router';

import { accessManagementMainRoute } from 'features/access-management';
import { analyticsRouteTree } from 'features/analytics';
import { assortmentRouteTree } from 'features/assortment';
import {
  merchantProductCatalogRouteTree,
  productCatalogRouteTree,
  productFamiliesMainRoute,
} from 'features/catalog/routes';
import { inventoryReplenishmentRouteTree } from 'features/inventory-replenishment';
import { aboutRoute } from 'features/landing/about';
import { accessDeniedRoute } from 'features/landing/access-denied';
import { emailLoginRouteTree } from 'features/landing/email-login';
import { loginRoute } from 'features/landing/login';
import { logoutRoute } from 'features/landing/logout';
import { merchantSelectionRoute } from 'features/landing/merchant-selection';
import { overrideManagementRouteTree } from 'features/override-management';
import { pricingRouteTree } from 'features/pricing';
import { pricingSettingsRouteTree } from 'features/pricing-settings';
import { financeRouteTree, invoicesLegacyRedirectRouteTree } from 'features/procurement/finance';
import { productInvestigationRouteTree } from 'features/product-investigation';
import { poRouteTree } from 'features/purchase-orders/routes';
import { salesVenuesRoute } from 'features/sales-venues';
import { selectionRecommendationsRouteTree } from 'features/selection-recommendations';
import { tasksRouteTree } from 'features/task-management';
import { userSettingsMainRoute } from 'features/user-settings';
import { offeringsDraftsRouteTree } from 'features/vendor-offerings';
import { vendorsRouteTree } from 'features/vendors';
import { venuesRoute } from 'features/venues';
import { vsaRouteTree } from 'features/vsa';
import { binLocationsRouteTree } from 'features/warehouse/bin-locations';
import { inventoryAdjustmentsRouteTree } from 'features/warehouse/inventory-adjustments';
import { opsReceivingRouteTree } from 'features/warehouse/ops-receiving/routeTree';
import { productAverageWeightRouteTree } from 'features/warehouse/product-average-weight/routeTree';
import { receivingRouteTree } from 'features/warehouse/receiving';
import { shrinkageRouteTree } from 'features/warehouse/shrinkage';
import { stockCountRouteTree } from 'features/warehouse/stock-count';
import { venueSettingsRouteTree } from 'features/warehouse/venue-settings';
import { warehousesRouteTree } from 'features/warehouses';
import { MerchantRedirect } from 'root/MerchantRedirect';

import { AuthVerification } from '../AuthVerification';
import { menuLayoutRoute } from '../MenuLayout';
import { MerchantVerification } from '../MerchantVerification';
import { rootRoute } from '../RootLayout';

export const authVerifiedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'auth',
  component: AuthVerification,
});

export const merchantVerifiedRoute = createRoute({
  getParentRoute: () => authVerifiedRoute,
  id: 'merchant',
  component: MerchantVerification,
});

const indexRoute = createRoute({
  getParentRoute: () => authVerifiedRoute,
  component: () => <MerchantRedirect />,
  path: '/',
});

export const ROUTE_TREE = rootRoute.addChildren({
  loginRoute,
  logoutRoute,
  aboutRoute,
  emailLoginRouteTree,
  accessDeniedRoute,
  authVerifiedRoute: authVerifiedRoute.addChildren({
    merchantSelectionRoute,
    indexRoute,
    merchantVerifiedRoute: merchantVerifiedRoute.addChildren({
      offeringsDraftsRouteTree,
      menuLayoutRoute: menuLayoutRoute.addChildren({
        vendorsRouteTree,
        inventoryReplenishmentRouteTree,
        invoicesLegacyRedirectRouteTree,
        financeRouteTree,
        poRouteTree,
        pricingRouteTree,
        pricingSettingsRouteTree,
        selectionRecommendationsRouteTree,
        overrideManagementRouteTree,
        productCatalogRouteTree,
        merchantProductCatalogRouteTree,
        productFamiliesMainRoute,
        analyticsRouteTree,
        opsReceivingRouteTree,
        userSettingsMainRoute,
        accessManagementMainRoute,
        venuesRoute,
        salesVenuesRoute,
        binLocationsRouteTree,
        assortmentRouteTree,
        stockCountRouteTree,
        tasksRouteTree,
        shrinkageRouteTree,
        receivingRouteTree,
        // NB: /inventory-movement removed in PR #9789, revert that commit to re-enable
        // inventoryMovementRouteTree,
        inventoryAdjustmentsRouteTree,
        productAverageWeightRouteTree,
        venueSettingsRouteTree,
        warehousesRouteTree,
        productInvestigationRouteTree,
        vsaRouteTree,
      }),
    }),
  }),
});
